import React, { useState } from "react";
import { Box, Container, Paper, Tab, Tabs, Typography, Stack } from "@mui/material";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import GroupsIcon from "@mui/icons-material/Groups";
import InsightsIcon from "@mui/icons-material/Insights";
import BarChartIcon from "@mui/icons-material/BarChart";

import WorklistTab from "../components/Worklist/WorklistTab";
import ByPatientTab from "../components/ByPatient/ByPatientTab";
import HedisPerformanceTab from "../components/Hedis/HedisPerformanceTab";
import ReportsTab from "../components/Reports/ReportsTab";

export default function CareGapsV2Page() {
  const [tab, setTab] = useState(0);
  const currentYear = new Date().getFullYear();

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ mb: 2 }}>
        <Box>
          <Typography variant="h4" fontWeight={900}>
            Care Gaps <span style={{ color: "#1976d2" }}>V2</span>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Worklist, HEDIS performance and reports — measurement year {currentYear}
          </Typography>
        </Box>
      </Stack>

      <Paper variant="outlined" sx={{ borderRadius: 3, mb: 2 }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            "& .MuiTab-root": { textTransform: "none", fontWeight: 600, minHeight: 56 },
          }}
        >
          <Tab icon={<AssignmentTurnedInIcon />} iconPosition="start" label="Worklist" />
          <Tab icon={<GroupsIcon />}             iconPosition="start" label="By Patient" />
          <Tab icon={<InsightsIcon />}           iconPosition="start" label="HEDIS Performance" />
          <Tab icon={<BarChartIcon />}           iconPosition="start" label="Reports" />
        </Tabs>
      </Paper>

      {tab === 0 && <WorklistTab measurementYear={currentYear} />}
      {tab === 1 && <ByPatientTab measurementYear={currentYear} />}
      {tab === 2 && <HedisPerformanceTab measurementYear={currentYear} />}
      {tab === 3 && <ReportsTab measurementYear={currentYear} />}
    </Container>
  );
}
